import React, { forwardRef, useState, useRef, useEffect } from 'react';
import { Hint } from '@flexiflow-ui-kit/hint';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled, { css } from 'styled-components';
import { Label } from '@flexiflow-ui-kit/label';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var InputSize;

(function (InputSize) {
  InputSize["Medium"] = "medium";
  InputSize["Large"] = "large";
})(InputSize || (InputSize = {}));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _labelStyle, _templateObject5, _inputLeftRightPaddin, _templateObject6, _templateObject7, _templateObject8, _inputStyle, _templateObject9;
var MainContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var InputContainer = styled.span(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  background-color: ", ";\n  ", ";\n"])), function (p) {
  return p.theme.palette.white;
}, function (p) {
  return inputStyle[p.size];
});
var labelStyle = (_labelStyle = {}, _defineProperty(_labelStyle, InputSize.Medium, css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([""])))), _defineProperty(_labelStyle, InputSize.Large, css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    font-size: 16px;\n    line-height: 24px;\n    margin-bottom: 8px;\n  "])))), _labelStyle);
var InputLabel = styled(Label)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  .label__text {\n    ", ";\n  }\n"])), function (p) {
  return labelStyle[p.size];
});
var inputLeftRightPadding = (_inputLeftRightPaddin = {}, _defineProperty(_inputLeftRightPaddin, InputSize.Medium, 8), _defineProperty(_inputLeftRightPaddin, InputSize.Large, 12), _inputLeftRightPaddin);
var IconContainer = styled.span(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  ", ": ", "px;\n  pointer-events: ", ";\n  align-items: center;\n  justify-content: center;\n  display: flex;\n  color: ", ";\n\n  svg {\n    cursor: ", ";\n  }\n"])), function (p) {
  return p.position;
}, function (p) {
  return inputLeftRightPadding[p.size] + 1;
}, function (p) {
  return p.disableIconEvents ? 'none' : 'auto';
}, function (p) {
  return p.theme.palette.gray['400'];
}, function (p) {
  return p.disabled ? 'not-allowed' : 'inherit';
});
var inputStyle = (_inputStyle = {}, _defineProperty(_inputStyle, InputSize.Medium, css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    height: 32px;\n  "])))), _defineProperty(_inputStyle, InputSize.Large, css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    height: 48px;\n  "])))), _inputStyle);
var NativeInput = styled.input(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n  font-size: 16px;\n  line-height: 20px;\n  display: block;\n  width: 100%;\n  box-sizing: border-box;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  border: 1px solid ", ";\n  color: ", ";\n  border-radius: 3px;\n  background-color: ", ";\n  outline: none;\n  position: absolute;\n  top: 0;\n\n  &:focus {\n    border-color: ", ";\n  }\n\n  &:disabled {\n    border-color: ", ";\n    background-color: ", ";\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &::-webkit-input-placeholder {\n    color: ", ";\n  }\n\n  &::-moz-placeholder {\n    color: ", ";\n  }\n\n  &:-ms-input-placeholder {\n    color: ", ";\n  }\n\n  &::-ms-input-placeholder {\n    color: ", ";\n  }\n\n  &::placeholder {\n    color: ", ";\n  }\n\n  &:disabled::placeholder {\n    color: ", ";\n  }\n\n  &::-ms-clear {\n    display: none;\n  }\n\n  &[type='number']::-webkit-inner-spin-button,\n  &[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n  }\n"])), function (p) {
  return inputStyle[p.inputSize];
}, function (_ref) {
  var iconLeftWidth = _ref.iconLeftWidth,
      inputSize = _ref.inputSize;
  return iconLeftWidth ? inputLeftRightPadding[inputSize] * 2 + iconLeftWidth : inputLeftRightPadding[inputSize];
}, function (_ref2) {
  var iconRightWidth = _ref2.iconRightWidth,
      inputSize = _ref2.inputSize;
  return iconRightWidth ? inputLeftRightPadding[inputSize] * 2 + iconRightWidth : inputLeftRightPadding[inputSize];
}, function (p) {
  return p.isError ? p.theme.palette.red['700'] : p.theme.palette.gray['400'];
}, function (p) {
  return p.theme.palette.black;
}, function (p) {
  return p.theme.palette.transparent;
}, function (p) {
  return p.isError ? p.theme.palette.red['700'] : p.theme.palette.blue['500'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['100'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
}, function (p) {
  return p.theme.palette.gray['500'];
});

var _excluded = ["disabled", "iconRight", "iconRightBehindInput", "iconLeftBehindInput", "iconLeft", "disableIconEvents", "hasError", "label", "labelCanDisabled", "labelCount", "labelMaxCount", "hint", "hintKeepPlace", "hintCanDisabled", "className", "autoComplete", "inputSize"];
var Input = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconRight = props.iconRight,
      _props$iconRightBehin = props.iconRightBehindInput,
      iconRightBehindInput = _props$iconRightBehin === void 0 ? false : _props$iconRightBehin,
      _props$iconLeftBehind = props.iconLeftBehindInput,
      iconLeftBehindInput = _props$iconLeftBehind === void 0 ? false : _props$iconLeftBehind,
      iconLeft = props.iconLeft,
      _props$disableIconEve = props.disableIconEvents,
      disableIconEvents = _props$disableIconEve === void 0 ? false : _props$disableIconEve,
      hasError = props.hasError,
      label = props.label,
      labelCanDisabled = props.labelCanDisabled,
      labelCount = props.labelCount,
      labelMaxCount = props.labelMaxCount,
      hint = props.hint,
      hintKeepPlace = props.hintKeepPlace,
      hintCanDisabled = props.hintCanDisabled,
      className = props.className,
      _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? 'off' : _props$autoComplete,
      _props$inputSize = props.inputSize,
      inputSize = _props$inputSize === void 0 ? InputSize.Medium : _props$inputSize,
      otherProps = _objectWithoutProperties(props, _excluded);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      iconLeftWidth = _useState2[0],
      setIconLeftWidth = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      iconRightWidth = _useState4[0],
      setIconRightWidth = _useState4[1];

  var iconLeftRef = useRef(null);
  var iconRightRef = useRef(null);
  useEffect(function () {
    if (iconLeftRef.current && iconLeftRef.current.offsetWidth) {
      setIconLeftWidth(iconLeftRef.current.offsetWidth);
    }
  }, [iconLeft]);
  useEffect(function () {
    if (iconRightRef.current && iconRightRef.current.offsetWidth) {
      setIconRightWidth(iconRightRef.current.offsetWidth);
    }
  }, [iconRight]);
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(MainContainer, {
    className: className
  }, /*#__PURE__*/React.createElement(Hint, {
    hasError: hasError,
    hint: hint,
    disabled: disabled,
    hintKeepPlace: hintKeepPlace,
    hintCanDisabled: hintCanDisabled
  }, /*#__PURE__*/React.createElement(InputLabel, {
    size: inputSize,
    hasError: hasError,
    label: label,
    labelCount: labelCount,
    labelMaxCount: labelMaxCount,
    disabled: disabled,
    labelCanDisabled: labelCanDisabled
  }, /*#__PURE__*/React.createElement(InputContainer, {
    size: inputSize
  }, !!iconLeft && iconLeftBehindInput && /*#__PURE__*/React.createElement(IconContainer, {
    className: "input__icon-left",
    disableIconEvents: disableIconEvents,
    disabled: disabled,
    position: "left",
    size: inputSize,
    ref: iconLeftRef
  }, iconLeft), !!iconRight && iconRightBehindInput && /*#__PURE__*/React.createElement(IconContainer, {
    ref: iconRightRef,
    disableIconEvents: disableIconEvents,
    disabled: disabled,
    position: "right",
    className: "input__icon-right",
    size: inputSize
  }, iconRight), /*#__PURE__*/React.createElement(NativeInput, _extends({
    inputSize: inputSize,
    ref: forwardedRef,
    className: className,
    iconLeftWidth: iconLeftWidth,
    iconRightWidth: iconRightWidth,
    iconLeftBehindInput: !!iconLeft && iconLeftBehindInput,
    iconRightBehindInput: !!iconRight && iconRightBehindInput,
    disabled: disabled,
    isError: hasError,
    autoComplete: autoComplete
  }, otherProps)), !!iconLeft && !iconLeftBehindInput && /*#__PURE__*/React.createElement(IconContainer, {
    className: "input__icon-left",
    disableIconEvents: disableIconEvents,
    disabled: disabled,
    position: "left",
    size: inputSize,
    ref: iconLeftRef
  }, iconLeft), !!iconRight && !iconRightBehindInput && /*#__PURE__*/React.createElement(IconContainer, {
    ref: iconRightRef,
    disableIconEvents: disableIconEvents,
    disabled: disabled,
    position: "right",
    className: "input__icon-right",
    size: inputSize
  }, iconRight))))));
});

export { Input, InputSize };
